angular.module("vgresiduos").controller("VertownNotificationsPopupCtrl", [
	"$scope",
	"$rootScope",
	"confirmDialog",
	"goToPageUrl",
	"notificationName",
	"popupData",
	"engagementScoreService",
	function ($scope, $rootScope, confirmDialog, goToPageUrl, notificationName, popupData, engagementScoreService) {
		"use strict";

		$scope.labels = $rootScope.labels;

		function initializePopup() {
			$scope.configuration = getPopupConfiguration();
		}

		initializePopup();

		function getPopupConfiguration() {
			const buttons = [
				{
					label: $scope.labels.I_AM_AWARE,
					class: "md-primary",
					click: function () {
						trackEventAction(Vgr.trackings.vertownNotifications.close);
						confirmDialog(true);
					}
				}
			];

			if (popupData.displayBehaviorId == Vgr.enumerations.vertownNotifications.displayBehavior.remindLater) {
				buttons.push({
					label: $scope.labels.REMIND_LATER,
					class: "md-primary",
					click: function () {
						trackEventAction(Vgr.trackings.vertownNotifications.remindLater);
						confirmDialog(false);
					}
				});
			}

			if (popupData.primaryButtonText) {
				buttons.push({
					label: popupData.primaryButtonText,
					class: "md-primary md-raised",
					click: function () {
						trackEventAction(Vgr.trackings.vertownNotifications.access);
						confirmDialog(true).then(function () {
							goToPageUrl(popupData.primaryButtonUrl);
						});
					}
				});
			}

			return {
				key: popupData.localStorageKey,
				imageLink: Vgr.constants.s3BaseUrl + popupData.imagePath,
				manualUrl: popupData.manualUrl,
				supportTextTypeId: popupData.supportTextTypeId,
				buttons: buttons
			};
		}

		$scope.getSupportText = function () {
			switch (popupData.supportTextTypeId) {
				case Vgr.enumerations.vertownNotifications.supportTextTypes.admin:
					return $scope.labels.GENERAL_TOP_ALERTS.CONTACT_YOUR_ADMIN;
				case Vgr.enumerations.vertownNotifications.supportTextTypes.support:
					return $scope.labels.GENERAL_TOP_ALERTS.CONTACT_OUR_SUPPORT;
			}
		};

		$scope.accessManual = function () {
			window.open(popupData.manualUrl);
		};

		function trackEventAction(event) {
			engagementScoreService.track(event, null, {
				Name: notificationName
			});
		}
	}
]);
